import { IconButton } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../../../components/TableContent';
import {
  LOADING_COL_OVERRIDES,
  LOADING_OFFERS_TOTAL_COLS,
  SKELETON_PROPS,
} from '../../../../utils/constants';

export const Desktop = () => (
  <TableContent direction="row" p={Spacing['stack.xxxs']} py={Spacing['inset.quarck']}>
    {Array.from({ length: LOADING_OFFERS_TOTAL_COLS }, (_, idx) => {
      const override = LOADING_COL_OVERRIDES.find((o) => o.idx === idx);
      const flex = override?.flex ?? 1;
      const isIcon = !!override?.isIcon;

      return (
        <TableContentItemColumn key={idx} flex={flex} alignItems={isIcon ? 'flex-end' : undefined}>
          {isIcon ? (
            <IconButton
              testId="remove-item"
              icon="Trash"
              iconColor={Color['neutral.light']}
              iconSize="xxs"
              borderRadius={BoxRadius.sm}
              w={Spacing['inline.sm']}
              h={Spacing['inline.sm']}
              p={0}
              isDisabled
            />
          ) : (
            <Skeleton {...SKELETON_PROPS} />
          )}
        </TableContentItemColumn>
      );
    })}
  </TableContent>
);
